import {SimplePage} from "../../elements/Pages";
import React from "react";

import {useQuery} from "@tanstack/react-query";
import {useAuth} from "../../../contexts/AuthContext";
import ListViewTable from "../../elements/tables/ListViewTable";
import {alumniApi} from "../../../api/alumni";

const columns = [
    {
        accessorFn: (row) => `${row.student.last_name}, ${row.student.first_name} ${row.student.student_number}`,
        id: "student_search",
        header: "SchülerIn",
        hide: true,
        enableColumnFilter: false,
    },
    {
        accessorKey: 'student',
        id: 'student',
        header: 'Name',
        columnType: 'alumni_student',
        enableColumnFilter: false,
        sortingFn: "lastNameSorting",
    },
    {
        accessorKey: "entry_date",
        id: "entry_date",
        columnType: "date",
        header: "Eintritt",
        enableColumnFilter: false,
    },
    {
        accessorKey: "exit_date",
        id: "exit_date",
        columnType: "date",
        header: "Austritt",
        enableColumnFilter: false,
    },
    {
        // accessorKey: "graduation_year",
        accessorFn: (row) => row.graduation_year ? `${row.graduation_year}` : null,
        id: "graduation_year",
        header: "Abi",
        enableColumnFilter: true,
        filterFn: "containsString",
        headerClassNames: "narrow-filter",
    },
    {
        accessorKey: "city",
        id: "city",
        header: "Stadt",
        filterFn: "containsString",
    },
    {
        accessorKey: "country",
        id: "country",
        header: "Land",
        enableColumnFilter: true,
        filterFn: "containsString",
    }
];

export default function AlumniList() {

    const {permissions} = useAuth();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["alumni"],
        () => alumniApi('get'),
        {refetchInterval: 1000 * 60 * 60}
    )

    function getRowLink(row) {
        return `/alumni/${row.original.id}`;
    }

    if (!data) return <></>
    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Ehemalige
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
